import useLoadUser from '@/hooks/useLoadUser';
import { getAppsMetadata } from '@/redux/actions/gravityActions';
import selectors from '@/redux/selectors/selectors';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const useAppsMetadata = () => {
  const { isLoaded, isLoggedIn } = useLoadUser();
  const companyId = useSelector(selectors.companyId);
  const appsMetadata = useSelector(selectors.appsMetadata);
  const lastAttemptedCompanyId = useRef(null);
  const hasAppsMetadata = appsMetadata?.length > 0;

  useEffect(() => {
    if (hasAppsMetadata) {
      // A later cache clear must be able to refill previously loaded metadata.
      lastAttemptedCompanyId.current = null;
      return;
    }

    if (!isLoaded || !isLoggedIn || !companyId || lastAttemptedCompanyId.current === companyId) {
      return;
    }

    // Empty results and failures must not turn Redux updates into automatic retries.
    lastAttemptedCompanyId.current = companyId;
    getAppsMetadata();
  }, [isLoaded, isLoggedIn, companyId, hasAppsMetadata]);

  return appsMetadata;
};

export default useAppsMetadata;
